import styles from "./Footer.module.scss";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Icons from "../../../asset/icons/index";
import useTranslations from "../../../hooks/useTranslations";
import { useOpenCloseAuthModalStore } from "../../../stores/Auth/useAuthModal";
import Images from "../../../asset/images";
const cx = classNames.bind(styles);

const defaultFooterSettings = {
  business_name: "Hộ Kinh Doanh Lianne Jewelry",
  tax_code: "049203005821",
  gov_link: "http://online.gov.vn/Website/chi-tiet-135323",
  gov_image: Images.bocongthuongImage,
  location_title: "",
  location_address: "",
  map_embed_url:
    "https://maps.google.com/maps?width=100%25&height=300&hl=en&q=16.040603,%20108.182487+(My%20Business%20Name)&t=&z=19&ie=UTF8&iwloc=B&output=embed",
  instagram_url: "https://www.instagram.com/lianne.jewelryy/",
  tiktok_url: "https://www.tiktok.com/@liannejewelryyy",
  youtube_url: "",
  facebook_url: "https://www.facebook.com/liannejewelryy/",
};

const emptyValueAllowedKeys = [
  "instagram_url",
  "tiktok_url",
  "youtube_url",
  "facebook_url",
];

function Footer() {
  const currentTranslations = useTranslations();
  const { open } = useOpenCloseAuthModalStore();
  const [footerSettings, setFooterSettings] = useState(defaultFooterSettings);

  // Fetch footer settings từ WordPress API
  useEffect(() => {
    fetch("/wp-json/custom/v1/footer-settings")
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.data) {
          const apiSettings = Object.keys(data.data).reduce((settings, key) => {
            if (
              data.data[key] !== "" ||
              emptyValueAllowedKeys.indexOf(key) !== -1
            ) {
              settings[key] = data.data[key];
            }

            return settings;
          }, {});

          setFooterSettings((currentSettings) => ({
            ...currentSettings,
            ...apiSettings,
          }));
        }
      })
      .catch((error) => {
        console.error("Error fetching footer settings:", error);
        // Sử dụng giá trị mặc định nếu fetch thất bại
      });
  }, []);

  const socialLinks = [
    {
      key: "instagram_url",
      url: footerSettings.instagram_url,
      icon: Icons.iconInsta,
      label: "instagram",
    },
    {
      key: "tiktok_url",
      url: footerSettings.tiktok_url,
      icon: Icons.iconTiktok,
      label: "tiktok",
    },
    {
      key: "youtube_url",
      url: footerSettings.youtube_url,
      icon: Icons.iconYoutube,
      label: "youtube",
    },
    {
      key: "facebook_url",
      url: footerSettings.facebook_url,
      icon: Icons.iconFB,
      label: "facebook",
    },
  ];

  const locationTitle =
    footerSettings.location_title || currentTranslations?.main_location?.title;
  const locationAddress =
    footerSettings.location_address ||
    currentTranslations?.main_location?.address;

  return (
    <div className={cx("footer")}>
      <div className={cx("footer__newsletter")}>
        <h6 className={cx("footer__title")}>
          {currentTranslations?.newsletter?.title}
        </h6>
        <p className={cx("footer_description")}>
          {currentTranslations?.newsletter?.description}
        </p>
        <div className={cx("footer__input")}>
          <label htmlFor="email" className={cx("input_label")}>
            <input
              placeholder={currentTranslations?.newsletter?.placeholder}
              className={cx("input")}
              id="email"
              type="email"
            />
            <span className={cx("input_span")} onClick={open}>
              {currentTranslations?.newsletter?.sign_up}
            </span>
          </label>
        </div>

        {/* Social media icons */}
        <div className={cx("footer__social")}>
          {socialLinks.map(
            (item) =>
              item.url && (
                <a
                  key={item.key}
                  href={item.url}
                  className={cx("social_link")}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.label}
                >
                  <img alt={item.label} src={item.icon} />
                </a>
              )
          )}
        </div>
      </div>

      <div className={cx("footer__content")}>
        <div className={cx("footer__section")}>
          <h6 className={cx("footer__title")}>
            <Link to={'/services'}> {currentTranslations?.customer_services?.title}</Link>
          </h6>
          <ul className={cx("footer__list")}>
            <li>
              <Link to={"/profile?tab=orders"} className={cx("footer__link")}>
                {currentTranslations?.customer_services?.track_order}
                {/* Theo Dõi Đơn Hàng */}
              </Link>
            </li>
            <li>
              <Link to={"/services#size-guide"} className={cx("footer__link")}>
                {currentTranslations?.customer_services?.size_guide}
                {/* Hướng Dẫn Đo Size Trang Sức */}
              </Link>
            </li>
            <li>
              <Link to={"/services#jewelry-care"} className={cx("footer__link")}>
                {currentTranslations?.customer_services?.jewelry_care}
                {/* Bảo Quản Trang Sức */}
              </Link>
            </li>
          </ul>
          <a
            href={footerSettings.gov_link}
            className={cx("footer__gov-link", "footer__gov-desktop")}
          >
            <img
              src={footerSettings.gov_image}
              alt="Bộ Công Thương"
              className={cx("footer__gov-img")}
            />
          </a>
        </div>

        <div className={cx("footer__section", "about_us")}>
          <h6 className={cx("footer__title")}>
            <Link to={'/about-us'}>{currentTranslations?.about_us?.title}</Link>
          </h6>
          <ul className={cx("footer__list")}>
            <li>
              <Link to={"/about-us"} className={cx("footer__link")}>
                {currentTranslations?.about_us?.our_story}
              </Link>
            </li>
            <li>
              <Link to={"/products/category"} className={cx("footer__link")}>
                {currentTranslations?.about_us?.store}
              </Link>
            </li>
          </ul>

        </div>

        <div className={cx("footer__section")}>
          <h6 className={cx("footer__title")}>
            <Link to={"/support"}>{currentTranslations?.support?.title}</Link>
          </h6>
          <ul className={cx("footer__list")}>
            <li>
              <Link
                to={"/support?section=warranty"}
                className={cx("footer__link")}
              >
                {currentTranslations?.support?.warranty_policy}
              </Link>
            </li>
            <li>
              <Link
                to={"/support?section=return"}
                className={cx("footer__link")}
              >
                {currentTranslations?.support?.return_refund_policy}
              </Link>
            </li>
            <li>
              <Link
                to={"/support?section=shipping"}
                className={cx("footer__link")}
              >
                {currentTranslations?.support?.shipping_delivery_policy}
              </Link>
            </li>
            <li>
              <Link
                to={"/support?section=privacy"}
                className={cx("footer__link")}
              >
                {currentTranslations?.support?.customer_data_privacy_policy}
              </Link>
            </li>
            <li>
              <Link
                to={"/support?section=payment"}
                className={cx("footer__link")}
              >
                {currentTranslations?.support?.payment_policy}
              </Link>
            </li>
          </ul>
        </div>

        <div className={cx("footer__section", "footer__location")}>
          <div className={cx("footer_location_info")}>
            <h6 className={cx("footer__title")}>
              {locationTitle}
            </h6>
            <p className={cx("location_text")}>
              {locationAddress}
            </p>
            <a
              href={footerSettings.gov_link}
              className={cx("footer__gov-link", "footer__gov-mobile")}
            >
              <img
                src={footerSettings.gov_image}
                alt="Bộ Công Thương"
                className={cx("footer__gov-img")}
              />
            </a>
                <span className={cx("footer__gov-mst")}>
                  {footerSettings.business_name} MST: {footerSettings.tax_code}
                </span>
          </div>
          <div className={cx("footer__map-desktop")}>
            <div style={{ width: "100%" }}>
              <iframe
                width="100%"
                height="300"
                title="Map Location Desktop"
                scrolling="no"
                src={footerSettings.map_embed_url}
              >
                <a href="https://www.mapsdirections.info/calcular-la-población-en-un-mapa">
                  Población en el Mapa
                </a>
              </iframe>
            </div>
          </div>
        </div>
        <div className={cx("footer__map-mobile")}>
          <div style={{ width: "100%" }}>
            <iframe
              width="100%"
              height="300"
              title="Map Location mobile"
              scrolling="no"
              src={footerSettings.map_embed_url}
            >
              <a href="https://www.mapsdirections.info/calcular-la-población-en-un-mapa">
                Población en el Mapa
              </a>
            </iframe>
          </div>
        </div>
      </div>

      <div className={cx("footer__bottom")}>
        <div className={cx("footer__copyright")}>
          <p>© APOLLONIAN, LLC</p>
        </div>
        <div className={cx("footer__legal")}>
          <a href="/" className={cx("legal_link")}>
            PRIVACY POLICY
          </a>
          <a href="/" className={cx("legal_link")}>
            TERMS OF USE
          </a>
          <a href="/" className={cx("legal_link")}>
            SITEMAP
          </a>
          <a href="/" className={cx("legal_link")}>
            DO NOT SELL MY INFORMATION
          </a>
          <a href="/" className={cx("legal_link")}>
            COOKIES
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
